import styled, { css } from "styled-components";

import { Popover, PopoverArrow } from "reakit/Popover";
import { REUSABLE_BOX_STYLES } from "core/Tooltip/styles";
import { AllButtonStyles } from "core/Button/styles";
import { AllCircleButtonStyles } from "core/CircleButton/styles";
import { focusOutline } from "core/links";

import { convertPxToRem } from "frontend/components/helpers";

// reusable constants:
export const ARROW_WIDTH_PX = 24;
export const ARROW_HEIGHT_PX = 12;

// styled components:
export const PopoverTriggerButton = styled.button`
    ${({ isCircleTrigger }) =>
        isCircleTrigger ? AllCircleButtonStyles : AllButtonStyles}

    // only show focus on keyboard not with mouse:
    &:focus:not(.focus-visible) {
        outline: none;
        box-shadow: none;
        border: none;
    }

    &:focus {
        ${focusOutline}
    }
`;

export const ReakitPopoverArrow = styled(PopoverArrow).attrs({
    // style tags are injected dynamically so this is how we override width & height:
    style: {
        width: convertPxToRem({ px: ARROW_WIDTH_PX }),
        height: convertPxToRem({ px: ARROW_HEIGHT_PX })
    }
})`
    ${({ placement }) => css`
        svg {
            position: relative;
            ${(placement === "bottom" ||
                placement === "bottom-start" ||
                placement === "bottom-end") &&
                css`
                    top: ${convertPxToRem({ px: -ARROW_HEIGHT_PX })};
                `}
        }
    `}
`;

export const Container = styled.div`
    color: ${({ darkMode }) =>
        REUSABLE_BOX_STYLES.BOX_TEXT_COLOR({ darkMode })};
    background-color: ${({ darkMode }) =>
        REUSABLE_BOX_STYLES.BOX_BACKGROUND({ darkMode })};
    border-radius: ${REUSABLE_BOX_STYLES.BOX_BORDER_RADIUS};
    max-width: ${REUSABLE_BOX_STYLES.BOX_MAX_WIDTH};
    box-shadow: ${({ darkMode }) =>
        darkMode
            ? REUSABLE_BOX_STYLES.BOX_SHADOW_DARK_MODE
            : REUSABLE_BOX_STYLES.BOX_SHADOW_LIGHT_MODE};
    padding: ${convertPxToRem({ px: 10 })};
    transition: opacity 250ms ease-in-out, transform 250ms ease-in-out;
    opacity: 0;
    transform-origin: top center;
    transform: translate3d(0, -20px, 0);

    ${({ isFluidWidth }) =>
        isFluidWidth
            ? css`
                  max-width: ${REUSABLE_BOX_STYLES.BOX_MAX_WIDTH};
              `
            : css`
                  width: ${convertPxToRem({ px: 240 })};
              `}

    [data-enter] & {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }

    // style the arrow because we can't pass darkMode to the PopoverArrow directly:
    ${ReakitPopoverArrow} svg path {
        fill: ${({ darkMode }) =>
            REUSABLE_BOX_STYLES.BOX_BACKGROUND({ darkMode })};
    }
`;

export const ReakitPopover = styled(Popover)`
    border: 0;
    background: none;
    padding: 0;
    z-index: 999999;

    &:focus {
        ${Container} {
            border-radius: ${REUSABLE_BOX_STYLES.BOX_BORDER_RADIUS};
            ${focusOutline}
        }
    }
`;

export const WrongPropTypeError = styled.div`
    color: red;
    font-size: ${convertPxToRem({ px: 48 })};
    line-height: ${convertPxToRem({ px: 48 })};
`;
